import { Component, OnInit } from '@angular/core';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { RestApiProvider } from 'src/app/services/shared/api.service';
import { SettingsService } from 'src/app/services/service.index';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ValidadoresService } from 'src/app/services/shared/validators';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/services/shared/dataShare.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  user: any;
  userInfo: any;
  form: FormGroup;
  showEdit = false;

  showImageProfile: boolean = true;

  imageChangedEvent: any = '';
  croppedImage: string = '';
  croppedBlob: Blob = null;

  constructor(
    private rest_api: RestApiProvider,
    private _settings: SettingsService,
    private _validators: ValidadoresService,
    private _toaster: ToastrService,
    private _dataShare: DataService
  ) { }

  ngOnInit() {

    this.form = new FormGroup({
      first_name: new FormControl(null, [Validators.required]),
      last_name: new FormControl(null, [Validators.required]),
      username: new FormControl(null),
      email: new FormControl(null,
        [Validators.required,
         Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")],
        this._validators.existeEmail.bind(this)
      ),
      userinfo: new FormGroup({
        phone: new FormControl(null, [Validators.required, this._validators.noDiezDigitosPhone]),
        birthdate: new FormControl(null),
        rfc: new FormControl(null)
      })
    });

    this._settings.cargarAjustes();
    this.userInfo = this._settings.ajustes.user;

    this.rest_api.get_usuario(this._settings.ajustes.user.id).then(response => {
      this.user = response;

      if (response['is_superuser'] === true) {
        (this.form.get('userinfo') as FormGroup).disable();
      } else {
        (this.form.get('userinfo') as FormGroup).reset(response['userinfo']);
      }

      this.form.reset(response);
      this.form.get('username').disable();
      this.form.updateValueAndValidity();
    });
    
  }
  edit(show: boolean) {
    this.showEdit = show;
  }

  private getUserinfoControl(controlName: string) {
    const userinfo = this.form.get('userinfo') as FormGroup;
    return userinfo ? userinfo.get(controlName) : null;
  }

  get first_nameNoValido() {
    const control = this.form.get('first_name');
    return control && control.invalid && control.touched;
  }

  get last_nameNoValido() {
    const control = this.form.get('last_name');
    return control && control.invalid && control.touched;
  }

  get usernameNoValido() {
    const control = this.form.get('username');
    return control && control.invalid && control.touched;
  }

  get emailNoValido() {
    const control = this.form.get('email');
    return control && control.invalid && control.touched;
  }

  get phoneNoValido() {
    const control = this.getUserinfoControl('phone');
    return control && control.invalid && control.touched;
  }

  get birthdateNoValido() {
    const control = this.getUserinfoControl('birthdate');
    return control && control.invalid && control.touched;
  }

  get rfcNoValido() {
    const control = this.getUserinfoControl('rfc');
    return control && control.invalid && control.touched;
  }

  // -------------------------------------
  // IMAGE CROPPING
  // -------------------------------------
  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.showImageProfile = false;
  }

  imageLoaded() {
    this._toaster.success('Imagen cargada');
  }

  cropperReady() {
    this._toaster.success('Imagen lista para recorte');
  }

  loadImageFailed() {
    this._toaster.error('Error al cargar la imagen');
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;

    const eventBlob = (event as any).blob as Blob | undefined;
    if (eventBlob) {
      this.croppedBlob = eventBlob;
      return;
    }

    // Convert base64 → blob manually (compatible con versiones viejas)
    if (!event.base64) {
      this.croppedBlob = null;
      return;
    }

    const [prefix, data] = event.base64.split(',');

    let contentType = 'image/png';
    if (prefix) {
      const typeSection = prefix.split(':')[1];
      if (typeSection) {
        const mime = typeSection.split(';')[0];
        if (mime) {
          contentType = mime;
        }
      }
    }

    this.croppedBlob = this.b64toBlob(data, contentType);
  }

  // Convert base64 string → Blob
  b64toBlob(b64Data: string, contentType: string): Blob {
    contentType = contentType || '';
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, { type: contentType });
  }

  // -------------------------------------
  // SUBIR AVATAR (CORRECTO)
  // -------------------------------------
  change_imagen(event: any) {

    if (!this.croppedBlob) {
      this._toaster.error("No hay imagen válida para subir");
      return;
    }
  
    const formData = new FormData();
    formData.append("avatar", this.croppedBlob, "avatar.png");
    // console.log("base64 length:", this.croppedImage.length);
    
    const endpoint = this.user.userinfo.url.replace('user-info', 'user-avatar-info');
  
    this.rest_api.parchar_url_media(endpoint, formData)
      .then((response: any) => {
        const avatarFromResponse = response && (response['avatar'] || (response as any).avatar);
        const cacheBustedAvatar = avatarFromResponse
          ? `${avatarFromResponse}${avatarFromResponse.indexOf('?') >= 0 ? '&' : '?'}t=${Date.now()}`
          : '';

        const resolvedAvatar = cacheBustedAvatar || avatarFromResponse;

        this.user.userinfo.avatar = resolvedAvatar;
        this._settings.ajustes.user.avatar = resolvedAvatar;
        if (this._settings.ajustes.user.userinfo) {
          (this._settings.ajustes.user.userinfo as any)['avatar'] = resolvedAvatar;
        }
        this._settings.guardarAjustes();
        this._dataShare.changeMessage({});
  
        this.showImageProfile = true;
        this._toaster.success('Imagen guardada correctamente');
      })
      .catch(err => {
        console.error(err);
        this._toaster.error('Error al guardar imagen');
      });
  }
  

  // -------------------------------------
  // VALIDACIONES DEL FORM
  // -------------------------------------
  save() {
    if (this.form.invalid) {

      Object.values(this.form.controls).forEach((control: any) => {
        control.markAsTouched();
      });

      return;
    }

    if (this.user && this.user.userinfo && this.user.userinfo.id &&
        this.form.value.userinfo) {
      this.form.value.userinfo.id = this.user.userinfo.id;
    }

    this.rest_api.parchar_url(this.user.url, this.form.value)
      .then(response => {
        this._toaster.success('Registro actualizado correctamente');
      })
      .catch(error => {
        console.error(error);
        this._toaster.error('Ocurrió un error');
      });
  }

}